// keycloak-js reports how a Keycloak action (UPDATE_PASSWORD, ...) ended through `onActionUpdate`, called while
// `init` processes the callback, and then strips kc_action_status from the URL. The account page mounts after
// that, so the outcome is kept here for it to read once (GROWTH-7870).
let lastAction = null;

/**
 * keycloak-js `onActionUpdate` handler.
 *
 * @param {string} status `success`, `cancelled` or `error`.
 * @param {string} action The action, e.g. `UPDATE_PASSWORD`.
 */
export const recordKeycloakAction = (status, action) => {
  lastAction = { status, action };
};

/**
 * Whether the member really changed their password on the return from Keycloak. The recorded outcome is
 * cleared, so it answers once: a remount, a stale link or a hand-typed `?type=` gets `false`.
 *
 * @returns {boolean}
 */
export const consumePasswordChangeConfirmed = () => {
  const outcome = lastAction;
  lastAction = null;

  return outcome?.status === "success" && outcome?.action === "UPDATE_PASSWORD";
};
